import { useLayoutEffect, useState, useEffect, useCallback } from "react";
import { Button, TextArea } from "devextreme-react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  askConfirmation,
  showResponseMessage,
  showErrorMessage,
  showWarningMessage,
} from "../../../helper/message.js";
import { assetService } from "../../../apis/apiServices/Asset.js";
import { AssetSubStatus } from "../../../helper/fixcode.js";
import Modal from "react-modal";
import { vishwamApi } from "../../../apis/apiServices/VishwamApi.js";
import {
  useGetCodeWiseAppModuleFeaturePermission,
  getStoredFeatureMenu,
} from "../../../helper/sessionHelper.js";
import { Loader } from "../../Shared/PageLoader";

export default function ViewAssetComponent(props) {
  const user = useSelector((state) => state.user.data);
  const location = useLocation();
  const navigate = useNavigate();
  const [state, setState] = useState({
    isApproved: false,
    isSendBackToDraft: false,
    isRecall: false,
    remark: "",
    isAddRemarkModalOpen: false,
    actionTypeId: 0,
    isCompleteLoading: false,
    loadingMessage: "",
  });
  const [errors, setErrors] = useState({
    remarkValidation: "",
  });
  const [assetData, setAssetData] = useState(null);  
  const { requestId, sourceUrl } = location.state || {};

  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = `Asset Request Preview`;
  }, []);

  let assetActionOnRequestfeaturePermission =
    useGetCodeWiseAppModuleFeaturePermission(
      "61f04c61-3c68-415e-ba46-5fc1a05cc4f8"
    );
  let assetRequestfeaturePermission =
    useGetCodeWiseAppModuleFeaturePermission("AM_A&L_AssetReq");

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: true,
      }));
      await getAssetDetails(requestId);
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: false,
      }));
    } catch (error) {
      console.log(error);
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: false,
      }));
    }
  }, []);

  const getAssetDetails = async (requestId) => {
    try {
      const response = await assetService.getassetDetailsById(
        requestId,
        user?.userId
      );
      setAssetData(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const isValidRemarkData = () => {
    let isValid = true;
    try {
      let err = { ...errors };
      err.remarkValidation = "";
      if (!state.remark) {
        isValid = false;
        err.remarkValidation = "Please enter remark.";
      }
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };

  const GetWorkFlowForApprovers = async (
    formId,
    formCategoryId,
    projectId,
    departmentId
  ) => {
    try {
      let body = {
        formId: formId,
        categoryId: formCategoryId || 0,
        projectId: projectId || 0,
        departmentId: departmentId || 0,
        companyId: user?.companyId || 0,
      };
      // if (
      //   body.formId > 0 &&
      //   body.categoryId > 0 &&
      //   body.projectId > 0 &&
      //   body.departmentId > 0
      // )
      {
        const response = await vishwamApi.getWorkFlowForApprovalForAsset(body);
        return response;
        //console.log(JSON.stringify(response));
        // setWorkflowData(response);
        // const stagesWithApprovers = response?.stages
        //   ?.filter((stage) => stage?.approvers && stage?.approvers?.length > 0)
        //   ?.map((stage) => ({
        //     actionTypeName: stage?.actionTypeName?.trim(), // optional: remove extra spaces or \r\n
        //     approvers: stage?.approvers,
        //   }));
        // const Approvers = response?.stages
        //   ?.filter((stage) => stage?.approvers && stage?.approvers?.length > 0)
        //   ?.flatMap((stage) =>
        //     stage?.approvers?.map((approver) => ({
        //       actionTypeId: stage?.actionTypeId,
        //       userId: approver?.userId,
        //       canEdit: approver?.canEdit,
        //       stageId: stage?.index,
        //     }))
        //   );
        // setAssetRequestApprovers(Approvers);
        // setAssetRequestApproversByWorkflow(stagesWithApprovers);
      }
      // console.log(Approvers);
    } catch (error) {
      console.log("Error getWorkFlowForApprovers===>", error);
    }
  };

  const handleOnUpdateAssetRequest = async (e) => {
    e.preventDefault();
    try {
      if (isValidRemarkData()) {
        let workflowCategoryId = 0;
        let categorybody = {
          formId: assetActionOnRequestfeaturePermission?.featureId,
          projectId: assetData.projectId,
          departmentId: assetData.departmentId,
        };
        const categoryresponse = await assetService.getWorkflowGroup(
          categorybody
        );
        if (categoryresponse?.data.length >= 1) {
          workflowCategoryId = categoryresponse?.data[0].workflowCategoryId;
        }

        let workflowData = await GetWorkFlowForApprovers(
          assetActionOnRequestfeaturePermission?.featureId,
          workflowCategoryId,
          assetData.projectId,
          assetData.departmentId
        );

        //console.log(JSON.stringify(workflowData));

        if (workflowData === null || workflowData === undefined) {
          await showErrorMessage(`Workflow not set for this category!!`);
          return;
        }

        let actionWorkflowCategoryId = 0;
        let actionCategorybody = {
          formId: assetRequestfeaturePermission?.featureId,
          projectId: assetData.projectId,
          departmentId: assetData.departmentId,
        };
        const actionCategoryresponse = await assetService.getWorkflowGroup(
          actionCategorybody
        );

        if (actionCategoryresponse?.data.length >= 1) {
          actionWorkflowCategoryId =
            actionCategoryresponse?.data[0].workflowCategoryId;
        }

        let actionWorkflowData = await GetWorkFlowForApprovers(
          assetRequestfeaturePermission?.featureId,
          actionWorkflowCategoryId,
          assetData.projectId,
          assetData.departmentId
        );

        //console.log(JSON.stringify(workflowData));

        const Approvers = actionWorkflowData?.stages
          ?.filter((stage) => stage?.approvers && stage?.approvers?.length > 0)
          ?.flatMap((stage) =>
            stage?.approvers?.map((approver) => ({
              actionTypeId: stage?.actionTypeId,
              userId: approver?.userId,
              canEdit: approver?.canEdit,
              stageId: stage?.index,
            }))
          );

        const lastStageData = Approvers.sort((a, b) => b.stageId - a.stageId);
        // Find the highest stageId
        const maxStageId = Math.max(...Approvers.map((item) => item.stageId));
        // Filter only those with the highest stageId
        const highestStageItems = Approvers.filter(
          (item) => item.stageId === maxStageId
        );
        var matchedStage = highestStageItems.filter(
          (e) => e.userId === user?.userId
        );

        let confirmationQuestion = `Are you sure want to approve asset request?`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isApproved: true }));

        let workflowCategory = {};
        workflowCategory.formId =
          assetActionOnRequestfeaturePermission?.featureId;
        workflowCategory.categoryId = workflowCategoryId;
        workflowCategory.projectId = assetData?.projectId;
        workflowCategory.departmentId = assetData?.departmentId;

        let body = {
          applicationId: 3,
          assetRequestId: assetData.requestId,
          statusId:
            matchedStage?.length > 0
              ? AssetSubStatus.AssetRequestApproved
              : AssetSubStatus.AssetRequestSendforApproval,
          remark: state.remark,
          userId: user?.userId,
          isMatchedStage: matchedStage?.length > 0 ? true : false,
          //isLoginUserRequester: Approvers?.[0]?.actionTypeId === 8 ? false : true,
          formName: assetActionOnRequestfeaturePermission?.featureName,
          //actionOnRequestStatusId: AssetSubStatus.AssetRequestApproved,
          formId: assetActionOnRequestfeaturePermission?.featureId,
          actionOnRequestStatusId: AssetSubStatus.ActionOnRequestPending,
          workflowId: workflowData.id,
          WorkflowCategoryRequest: workflowCategory,
          isSentForApproval: false,
        };

        const response = await assetService.updateAssetRequestStatus(body);
        if (!response?.isSuccess && response.statusCode === 200) {
          //For showing warning message....in case of it is send back to draft
          await showWarningMessage(response?.message);
          setState((prev) => ({
            ...prev,
            isApproved: false,
            isAddRemarkModalOpen: false,
          }));
          return;
        }
        isConfirmed = await showResponseMessage(response);
        setState((prev) => ({ ...prev, isApproved: false }));
        if (response?.isSuccess) {
          if (location.state.sourceUrl === "MyTasks") {
            navigate("/MyTasks");
          } else if (sourceUrl === "AssetRequest") {
            navigate("/AssetRequest");
          } else if (sourceUrl === "ApprovedAssetRequest") {
            navigate("/ApprovedAssetRequest");
          } else {
            navigate("/MyTasks");
          }
        }
      }
    } catch (error) {
      setState((prev) => ({ ...prev, isApproved: false }));
      console.log(error);
    }
  };

  const handleOnBackToDraftAssetRequest = async (e) => {
    e.preventDefault();
    try {
      if (isValidRemarkData()) {
        let confirmationQuestion = `Are you sure want to send asset request back to draft?`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isSendBackToDraft: true }));

        const response = await assetService.sendAssetRequestBackToDraft(
          assetData.requestId,
          user?.userId,
          state.remark
        );
        if (!response?.isSuccess && response.statusCode === 200) {
          //For showing warning message....in case of it is send back to draft
          await showWarningMessage(response?.message);
          setState((prev) => ({
            ...prev,
            isSendBackToDraft: false,
            isAddRemarkModalOpen: false,
          }));
          return;
        }
        isConfirmed = await showResponseMessage(response);
        setState((prev) => ({ ...prev, isSendBackToDraft: false }));
        if (response?.isSuccess) {
          if (location.state.sourceUrl === "MyTasks") {
            navigate("/MyTasks");
          } else if (sourceUrl === "AssetRequest") {
            navigate("/AssetRequest");
          } else if (sourceUrl === "ApprovedAssetRequest") {
            navigate("/ApprovedAssetRequest");
          }
        }
      }
    } catch (error) {
      setState((prev) => ({ ...prev, isSendBackToDraft: false }));
      console.log(error);
    }
  };

  const handleOnBackToDraftAssetReCall = async (e) => {
    e.preventDefault();
    try {
      if (isValidRemarkData()) {
        let confirmationQuestion = `Are you sure want to recall asset request?`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isRecall: true }));
        const response = await assetService.sendAssetRequestBackToReCall(
          assetData.requestId,
          user?.userId,
          state.remark
        );
        isConfirmed = await showResponseMessage(response);
        setState((prev) => ({ ...prev, isRecall: false }));
        if (response?.isSuccess) {
          if (location.state.sourceUrl === "MyTasks") {
            navigate("/MyTasks");
          } else if (sourceUrl === "AssetRequest") {
            navigate("/AssetRequest");
          } else if (sourceUrl === "ApprovedAssetRequest") {
            navigate("/ApprovedAssetRequest");
          }
        }
      }
    } catch (error) {
      setState((prev) => ({ ...prev, isRecall: false }));
      console.log(error);
    }
  };

  const handleOnOpenAddRemarkModal = (actionTypeId) => {
    try {
      setState((prev) => ({
        ...prev,
        isAddRemarkModalOpen: true,
        actionTypeId: actionTypeId,
      }));
      let err = { ...errors };
      err.remarkValidation = "";
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnCloseAddRemarkModal = () => {
    try {
      setState((prev) => ({
        ...prev,
        isAddRemarkModalOpen: false,
        remark: "",
        isSendBackToDraft: false,
        isApproved: false,
        isRecall: false,
        actionTypeId: 0,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  // useEffect(() => {
  //     const approvedDate = (assetData?.approvers || []).find(
  //         approver => approver.userId === user?.userId
  //     )?.approvedDate;

  //     if (!approvedDate) return;

  //     const interval = setInterval(() => {
  //         const secondsDiff = getTimeDifferenceInSeconds(approvedDate);
  //         if (secondsDiff > 300) {
  //             setDisableRecallButton(true);
  //             clearInterval(interval); // Stop further checks
  //         }
  //     }, 1000); // every 5 seconds

  //     return () => clearInterval(interval); // Cleanup on unmount
  // }, [assetData, user]);

  return (
    <>
      <div className="content">
        <div className="card top-bottom">
          <div className="card-body">
            <Button
              text="Back"
              icon="back"
              onClick={() => {
                if (sourceUrl === "AssetRequest") {
                  navigate("/AssetRequest");
                } else if (sourceUrl === "ReportAssetRequest") {
                  navigate("/ReportAssetRequest");
                } else if (sourceUrl === "MyTasks") {
                  navigate("/MyTasks");
                } else if (sourceUrl === "ApprovedAssetRequest") {
                  navigate("/ApprovedAssetRequest");
                }
              }}
              stylingMode="outlined"
              type="default"
              className="mr-2"
              hint="Back"
            />
            {/* <button className='btn btn-primary btn-sm' title='Print' onClick={handlePrint}><i className="fas fa-print"></i> Print</button> */}
            {/* {assetData?.statusId === AssetSubStatus.AssetRequestSendforApproval &&
              assetData?.toId === user?.userId && ( */}
            {!location?.state?.isReport && (
              <>
                {assetData?.isApproved === true && (
                  <>
                    <button
                      type="button"
                      className="btn btn-success btn-sm"
                      hidden={!props?.featurePermission?.canApprove}
                      onClick={() => {
                        handleOnOpenAddRemarkModal(1);
                      }}
                    >
                      <span title="Approve">
                        <i
                          className={`fas fa-${
                            state.isAssentApprove ? "spinner fa-spin" : "check"
                          }`}
                        />
                        &nbsp;&nbsp;Approve
                      </span>
                    </button>
                    &nbsp;&nbsp;
                  </>
                )}
                {assetData?.isSendBackToDraft === true && (
                  <>
                    <button
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={() => {
                        handleOnOpenAddRemarkModal(2);
                      }}
                    >
                      <span title="Back to Draft">
                        <i
                          className={`fas fa-${
                            state.isSendBackToDraft
                              ? "spinner fa-spin"
                              : "arrow-left"
                          }`}
                        />
                        &nbsp;&nbsp;Back to Draft
                      </span>
                    </button>
                    &nbsp;&nbsp;
                  </>
                )}
                {assetData?.isRollBack === true && (
                  <>
                    <button
                      type="button"
                      className="btn btn-outline-danger btn-sm"
                      onClick={() => {
                        handleOnOpenAddRemarkModal(3);
                      }}
                    >
                      <span title="Recall">
                        <i
                          className={`fas fa-${
                            state.isRecall ? "spinner fa-spin" : "undo"
                          }`}
                        />
                        &nbsp;&nbsp;Recall
                      </span>
                    </button>
                    &nbsp;&nbsp;
                  </>
                )}
              </>
            )}
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={async (e) => {
                window.print();
              }}
            >
              <span title="Print">
                <i className="fas fa-print" />
                &nbsp;&nbsp;Print
              </span>
            </button>
          </div>
        </div>
        <div className="row">
          {/* {isPreviewOnly && <div className='col-lg-2 col-md-3'></div>} */}
          {/* <div ref={contentRef}> */}
          <div className={"col-lg-9 col-md-6"}>
            <div className="card">
              <div className="card-body">
                <table width="100%" className="page-header">
                  <tr>
                    <td>
                      <div className="imglogo mt-2">
                        <img
                          src="https://vishwasamudra.in/wp-content/uploads/2022/11/New-Project.png"
                          alt="DigilinkZ | Streamlining Storage, Access & Organization"
                          width="150"
                          className=""
                        />
                      </div>
                    </td>
                    <td align="right">
                      <h6
                        className="mb-1"
                        style={{ fontSize: "0.8rem", color: "#282C7D" }}
                      >
                        Registered Office
                      </h6>
                      <p className="mb-0 pb-0 small">
                        8th & 9th Floors, Vamsiram Jyothi Valencia,<br></br>
                        Road No. 2, Banjara Hills, Hyderabad – 500034
                      </p>
                    </td>
                  </tr>
                </table>
                <div
                  className="text-center mt-5 mb-4 imo-page-title"
                  style={{
                    backgroundColor: "#ebebeb",
                    paddingTop: "7px",
                    paddingBottom: "7px",
                    border: "1px solid #ebebeb",
                  }}
                >
                  <table width="100%">
                    <tr>
                      <td className="text-center">
                        <h4
                          className="mb-0"
                          style={{ fontWeight: "700", color: "#282c7d" }}
                        >
                          ASSET REQUEST
                        </h4>
                        <h6 className="mb-0 mr-3" style={{ fontWeight: "600" }}>
                          {assetData?.requestNo}
                        </h6>
                      </td>
                      {/* <td width="50%" className='text-right'></td> */}
                    </tr>
                  </table>
                </div>
                <div className="imo-basic-detail">
                  <table cellPadding="2">
                    <tr>
                      <td width="80px" style={{ fontSize: "0.9rem" }}>
                        From
                      </td>
                      <td
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#282C7D",
                        }}
                      >
                        {assetData?.fromName}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: "0.9rem" }}>To</td>
                      <td
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#282C7D",
                        }}
                      >
                        {assetData?.toName}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: "0.9rem" }}>Site</td>
                      <td
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#282C7D",
                        }}
                      >
                        {assetData?.projectName}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: "0.9rem" }}>FR No.</td>
                      <td
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#282C7D",
                        }}
                      >
                        {assetData?.requestNo}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: "0.9rem" }}>Date</td>
                      <td
                        style={{
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#282C7D",
                        }}
                      >
                        {assetData?.requestedDate
                          ? new Date(
                              assetData?.requestedDate
                            ).toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                            })
                          : ""}
                      </td>
                    </tr>
                  </table>
                </div>
                <div>
                  <hr></hr>
                </div>
                <div className="message-body">
                  <table width={"100%"} className="asset-details">
                    <thead>
                      <tr>
                        <th>Asset Request No</th>
                        <th>Asset Description</th>
                        <th>Required Qty</th>
                        <th>Duration Required (In months)</th>
                        <th>Date of Requirement</th>
                        <th>Purpose</th>
                      </tr>
                    </thead>
                    <tbody>
                      {assetData?.assetRequestSub?.map((item, index) => (
                        <tr key={index}>
                          <td>{item?.requestNo}</td>
                          <td>{item?.categoryName}</td>
                          <td>{item?.requiredQty}</td>
                          <td>{item?.durationInMonths}</td>
                          <td>{item?.requirementDate}</td>
                          <td>{item?.purpose}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="page-footer">www.vishwasamudra.in</div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-3 reviews">
            <div className="card">
              <div className="card-body">
                <div className="mb-1 sub-title-color">REMARKS</div>
                <div className="list-group">
                  {assetData?.history?.map((item, index) => (
                    <div
                      key={index}
                      className="list-group-item list-group-item-action flex-column align-items-start"
                      style={{
                        borderBottom: "1px solid #cfcfcf",
                        marginBottom: "0.5rem",
                        paddingBottom: "0.5rem",
                      }}
                    >
                      <div
                        className="small mb-1"
                        style={{ color: "#282c7d", fontWeight: "500" }}
                      >
                        {item.statusName === "Recall"
                          ? "Recall Requested"
                          : item.statusName}{" "}
                        by {item.fullName}
                      </div>
                      <div className="d-flex w-100 justify-content-between align-items-center">
                        <small>Message</small>
                        <small>
                          {item.remarkDate ?? ""}
                          {/* {item.remarkDate
                            ? new Date(item.remarkDate).toLocaleDateString('en-GB', {
                              day: '2-digit',
                              month: '2-digit',
                              year: 'numeric'
                            }) +
                            ' ' +
                            new Date(item.remarkDate).toLocaleTimeString('en-GB', {
                              hour: '2-digit',
                              minute: '2-digit',
                              hour12: true
                            })
                            : ''} */}
                        </small>
                      </div>
                      <div
                        className="small"
                        style={{ fontSize: "0.8rem", fontStyle: "italic" }}
                      >
                        {item.remarks}
                      </div>
                      {/* <div className="d-flex w-100 justify-content-between align-items-center">
                        <small>{item?.updatedOn}</small>
                      </div>
                      <div
                        className="small"
                        style={{ fontSize: "0.8rem", fontStyle: "italic" }}
                      >
                        {item.statusName}
                      </div> */}
                    </div>
                  ))}
                </div>
              </div>
            </div>
            {assetData?.assetRequestAttachments?.length === 0 ? (
              ""
            ) : (
              <div className="card">
                <div className="card-body">
                  <div className="mb-1 sub-title-color">ATTACHMENTS</div>
                  {assetData?.assetRequestAttachments?.map((item, index) => (
                    <div className="list-group">
                      <div
                        key={index}
                        className="list-group-item list-group-item-action flex-column align-items-start"
                        style={{
                          borderBottom: "1px solid #cfcfcf",
                          marginBottom: "0.5rem",
                          paddingBottom: "0.5rem",
                        }}
                      >
                        <div className="d-flex w-100 justify-content-between align-items-center">
                          <small
                            style={{ cursor: "pointer", color: "blue" }}
                            onClick={() => {
                              window.open(item?.fileUrl, "_blank");
                            }}
                          >
                            {item?.assetFileName}
                            {/* item?.fileType */}
                          </small>
                          <small>{item?.fileSize} kb</small>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
        {/* <div><hr></hr></div>
        <div className='message-body' dangerouslySetInnerHTML={{ __html: assetData?.iomContent }}></div>
        <table width="100%" cellPadding="0" className='approvers'>
          <tr>
            {assetData?.approvers.map((approver, index) => {
              let label = '';
              if (approver?.statusId === 2) {
                label = 'Recommended By,';
              } else if (approver?.statusId === 3) {
                label = 'Drafted By,';
              } else if (approver?.statusId === 7) {
                label = 'Verified By,';
              } else if (approver?.statusId === 1) {
                label = 'Approved By,';
              }
              return approver?.statusId > 0 && (
                <td width="30%" align='center'>
                  <div key={index}>
                    {label && (
                      <h6 className='mb-0' style={{ fontSize: '0.9rem', fontStyle: 'normal', fontWeight: '400' }}>
                        {label}
                      </h6>
                    )}
                    <>
                      <div className='sender-name' style={{ height: '70px', paddingTop: '8px', position: 'relative' }}>
                        {approver?.approvedDate &&
                          <>
                            <div className='signature'>
                              <img src="./assets/img/logo-vs-symbol.png" className="img-fluid logo-brand-image" />
                            </div>
                            <div className='digital-sign'>
                              <div>Digitally signed by {approver?.firstName} {approver?.lastName}</div>
                              <div>Date: {new Date(approver?.approvedDate).toLocaleDateString('en-GB', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: true
                              })}
                              </div>
                            </div>
                          </>
                        }
                      </div>

                      <div className='sender-name' style={{
                        borderTop: '1px solid #cfcfcf',
                        paddingTop: '0.5rem',
                        fontSize: '0.9rem',
                        fontWeight: '500'
                      }}>
                        {approver?.firstName} {approver?.lastName}
                      </div>
                      <div className='sender-department' style={{ fontSize: '0.8rem' }}>
                        {approver?.designationName}
                      </div>
                    </>
                  </div>
                </td>
              );
            })}
          </tr>
        </table> */}
        <div className="web-page-footer">www.vishwasamudra.in</div>
      </div>

      {/* For Adding Remark (Approve/Back To Draft/Recall) */}
      <Modal
        ariaHideApp={false}
        isOpen={state.isAddRemarkModalOpen}
        className={"react-modal custom-modal-small"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Adding Remark (Approve/Back To Draft/Recall)"
      >
        <div className="modal-header">
          <h6 className="modal-title">
            {state.actionTypeId === 1
              ? "Approval"
              : state.actionTypeId === 2
              ? "Send Back To Draft"
              : state.actionTypeId === 3
              ? "Recall"
              : ""}
          </h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              handleOnCloseAddRemarkModal();
            }}
          >
            <span aria-hidden="true">x</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-12 col-lg-12">
              <div className="form-group mb-2">
                <label>
                  Remark&nbsp;<span className="text-danger">*</span>
                </label>
                <TextArea
                  className="form-control"
                  placeholder="Enter remark"
                  showClearButton={true}
                  height={150}
                  valueChangeEvent="keyup"
                  value={state.remark}
                  onValueChanged={(e) => {
                    let err = { ...errors };
                    err.remarkValidation = "";
                    setErrors(err);
                    setState((prev) => ({
                      ...prev,
                      remark: e.value,
                    }));
                  }}
                />
                {errors.remarkValidation && (
                  <div className="text-danger">{errors.remarkValidation}</div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-primary btn-sm"
            title="Submit"
            onClick={async (e) => {
              if (state.actionTypeId === 1) {
                await handleOnUpdateAssetRequest(e);
              } else if (state.actionTypeId === 2) {
                await handleOnBackToDraftAssetRequest(e);
              } else if (state.actionTypeId === 3) {
                await handleOnBackToDraftAssetReCall(e);
              }
            }}
            disabled={
              state.actionTypeId === 1
                ? state.isApproved
                : state.actionTypeId === 2
                ? state.isSendBackToDraft
                : state.actionTypeId === 3
                ? state.isRecall
                : false
            }
          >
            <span title="Submit">
              {state.actionTypeId === 1 ? (
                <>
                  <i
                    className={`fas fa-${
                      state.isApproved ? `spinner fa-spin` : `check`
                    }`}
                  />
                </>
              ) : state.actionTypeId === 2 ? (
                <>
                  <i
                    className={`fas fa-${
                      state.isSendBackToDraft ? `spinner fa-spin` : `check`
                    }`}
                  />
                </>
              ) : state.actionTypeId === 3 ? (
                <>
                  <i
                    className={`fas fa-${
                      state.isRecall ? `spinner fa-spin` : `check`
                    }`}
                  />
                </>
              ) : null}
              &nbsp;&nbsp;Submit
            </span>
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            title="Cancel"
            onClick={() => {
              handleOnCloseAddRemarkModal();
            }}
          >
            <i className="fas fa-times"></i>&nbsp;&nbsp;Cancel
          </button>
        </div>
      </Modal>

      {state.isCompleteLoading && (
        <Loader loadingMessage={state.loadingMessage} />
      )}
    </>
  );
}
